import styled from "styled-components";
import { Swiper } from "swiper/react/swiper-react";

import yelloMark from "../../../../image/assets/yellow-mark.png";

export const StyledSection = styled.section`
  color: var(--text-color-dark);
  h3 mark {
    color: inherit;
    background: url(${yelloMark}) no-repeat 0 25px;
    background-size: 100% 20px;
  }
`;

export const WrapperImg = styled.img`
  margin-bottom: ${({ $top }) => $top && "-2px"};
  margin-top: ${({ $bottom }) => $bottom && "-2px"};
  transform: ${({ $bottom }) => $bottom && "rotate(180deg)"};
  @media screen and (max-width: 528px) {
    margin-bottom: ${({ $top }) => $top && "-8px"};
    margin-top: ${({ $bottom }) => $bottom && "-8px"};
  }
`;

export const SectionInnerWrapper = styled.div`
  background: var(--blue-color-light);
`;

export const StyledSwiper = styled(Swiper)`
  div.swiper-wrapper {
    padding: 3rem 0 6rem;
    @media screen and (max-width: 768px) {
      padding-top: 1rem;
    }
  }
  .swiper-pagination {
    left: 50%;
    transform: translateX(-50%);
    width: auto;
  }
  .swiper-pagination-bullet {
    @media screen and (min-width: 768px) {
      height: 12px;
      width: 12px;
    }
    &.swiper-pagination-bullet-active {
      background-color: var(--primary-color);
    }
  }
`;

export const SwiperButtonsWrapper = styled.div`
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  width: ${({ $freeSimsCount }) =>
    $freeSimsCount && `calc(250px + (${$freeSimsCount} * 8px))`};
  justify-content: space-between;
  @media screen and (max-width: 320px) {
    width: 100%;
  }
`;

export const SwiperButton = styled.button`
  border: none;
  background: none;
`;
